<template>
    <div class="flex space-x-8">
        <Link v-for="category in mainCategories"
              :key="category.id"
              :href="category.url"
              :class="[
                  category.is_active ? 'border-blue-500 text-slate-900 dark:text-white' : 'border-transparent text-slate-500 hover:border-slate-300 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-300',
                  'inline-flex items-center xxxpx-1 pt-1 border-b-2 text-sm font-medium'
              ]">
            {{ category.name }}
        </Link>
    </div>
</template>

<script setup>
import {Link} from '@inertiajs/vue3'

defineProps({
    mainCategories: {
        type: Array,
        required: true
    }
})
</script>
